import React, { Component } from 'react';
import PageLoader from "./PageLoader";
import '../../static/button.css';

export class Button extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showIcon: false,
			activated: false
		};
	}

	componentWillReceiveProps(nextProps) {
		// PIL.logger().log(this.constructor.name, "componentWillReceiveProps()", nextProps);

		if (this.props.activated && !nextProps.activated) {
			this.setState({ showIcon: true }, () => {
				setTimeout(() => { this.setState({ showIcon: false }); }, 6000);
			});
		}
		else if (!this.props.activated && nextProps.activated) {
			this.setState({ showIcon: false });
		}
	}

	render() {
		// PIL.logger().log(this.constructor.name, "render()", this.props, this.state);

		let icon = "fa-check";
		if (this.props.error) {
			icon = "fa-times";
		}

		let feedbackPosition = this.props.feedbackPosition === "right" ? "right" : "left";

		// e.currentTarget.attributes['tag'].value;

		let buttonLabel = this.props.label;
		let formLock = this.props.formLock;

		let wrapClasses = "control-wrapper control-button";
		let wrapStyles = this.props.wrapStyles ? this.props.wrapStyles : {};
		wrapClasses += this.props.activated ? " " + "control-button-activated" : "";
		wrapClasses += this.props.wrapClass ? " " + this.props.wrapClass : "";

		let buttonClasses = "waves-effect waves-light btn";
		buttonClasses += formLock ? " display-none" : "";
		buttonClasses += this.props.buttonClass ? " " + this.props.buttonClass : "";
		let buttonStyle = this.props.buttonStyle ? this.props.buttonStyle : {};

		return (
			<div className={wrapClasses} style={wrapStyles}>
				{this.props.showFeedback && feedbackPosition === "left" ?
					<i className={"left-position fa " + icon + (this.state.showIcon ? "" : " visibility-hidden")}></i>
					: ""
				}

				<button
					className={buttonClasses}
					style={buttonStyle}
					onClick={this.props.onClick}
					disabled={this.props.disabled}
				>
					<PageLoader loading={this.props.activated} small={true} radius="11" />
					{this.props.iconClass ?
						<i className={"button-icon " + this.props.iconClass}></i>
						:
						""
					}
					{this.props.children}
				</button>

				{this.props.showFeedback && feedbackPosition === "right" ?
					<i className={"right-position fa " + icon + (this.state.showIcon ? "" : " visibility-hidden")}></i>
					: ""
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/global/Button.js